/**
 * ------------------------------------------------------------
 * Options Theme
 * Global JavaScript
 * ------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('Options Theme Loaded');
});